







import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryFinanceAssetDailyBalanceList, ExportFinanceAssetDailyBalance } from '@/api'
import { DateFormat, DateFormat2 } from '@/utils/date/DateUtil'

@Component({ components: { VQuery, VTable } })
export default class FinanceAssetDailyBalanceList extends Vue {
  private queryParam: any = {
    startRow: 1,
    limit: 10,
    statDateDaterange: [],
    orderBy: 'stat_date desc',
    statDateTimeScope: '',
    assetType: undefined,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private tableSelectData: any[] = []
  private queryModels: Array<QueryModel> = [
    { title: '统计日期', param: 'statDateDaterange', type: 'daterange' },
    { title: '资产类型', param: 'assetType', type: 'select', selectData: [
      { label: '绿豆', value: 1 }, { label: '积分', value: 2 },
    ] },
  ]
  private queryOperation: Array<TableOperation> = [
    { title: '导出', type: 'warning', click: this.exportHandle },
  ]
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '统计日期', param: 'statDate', width: 120 },
    { title: '资产', param: 'assetType', formatter: (r: any) => r.assetType === 2 ? '积分' : '绿豆' },
    { title: '期初', param: 'beginBalance' },
    { title: '当日入账', param: 'dayInTotal' },
    { title: '当日出账', param: 'dayOutTotal' },
    { title: '净变动', param: 'dayNetTotal' },
    { title: '期末(计算)', param: 'endBalanceCalc' },
    { title: '余额快照', param: 'balanceSnapshot' },
    { title: '勾稽差额', param: 'reconcileDiff' },
    { title: '说明', param: 'reconcileNote', width: 200, overflow: true },
    { title: '更新时间', param: 'updateTime', formatter: DateFormat, width: 160 },
    { title: '操作', type: 'operation', width: 100, operation: [
      { title: '归类明细', type: 'text', click: this.goCategoryHandle },
    ] },
  ]

  public created() {
    if (this.$route.query.assetType) {
      this.queryParam.assetType = Number(this.$route.query.assetType)
    }
    this.loadData()
  }
  private tableSelectChange(e: any[]) { this.tableSelectData = e }
  private goCategoryHandle(row: any) {
    const day = DateFormat2(row.statDate)
    const assetType = row.assetType != null ? String(row.assetType) : '1'
    this.$router.push({
      path: '/statistical/financeWealthWayCategoryList',
      query: { statDate: day, assetType },
    })
  }
  private exportHandle() {
    const loading = this.$loading({ lock: true, text: '正在导出', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
    const param: any = this.getRequestParam()
    param.limit = ''
    param.startRow = ''
    if (this.tableSelectData.length > 0) param.ids = this.tableSelectData.map(e => e.id)
    ExportFinanceAssetDailyBalance(param, '资产日终余额勾稽.xlsx').finally(() => loading.close())
  }
  public async loadData() {
    const result = await QueryFinanceAssetDailyBalanceList(this.getRequestParam())
    this.tableTotal = result.total
    this.tableData = result.list
  }
  private getRequestParam() {
    const param = { ...this.queryParam }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.statDateDaterange.length > 0) {
      param.statDateTimeScope = DateFormat(param.statDateDaterange[0]) + ',' + DateFormat(param.statDateDaterange[1])
    }
    return param
  }
  public search() { this.tableCurrntPage = 1; this.loadData() }
  public pageChange(index: number) { this.tableCurrntPage = index; this.loadData() }
  public sizeChange(index: number) { this.tableCurrntPage = 1; this.queryParam.limit = index; this.loadData() }
}
